import { render } from "./user-form-page.vue?vue&type=template&id=05723247&scoped=true"
import script from "./user-form-page.vue?vue&type=script&lang=js"
export * from "./user-form-page.vue?vue&type=script&lang=js"

import "./user-form-page.vue?vue&type=style&index=0&id=05723247&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05723247"]])

export default __exports__